module.exports = __webpack_public_path__ + "img/arrow-down-right-square.71814c8c.svg";